import script from "./LangSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LangSwitcher.vue?vue&type=style&index=0&id=8cd6554a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cd6554a"]])

export default __exports__